import ProcessLegal from "./Process.vue"
export default ProcessLegal